import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import queryString from 'query-string';
import ReactGA from 'react-ga';

import App from './components/App/App';
import './index.css';



// the id of the div to render too
let appId = `${process.env.REACT_APP_APP_ID}` ? `${process.env.REACT_APP_APP_ID}` : 'globalcalendar';
let initParams = {};
const CODE_MISSING = 'codeMissing';

initParams.calendarUrl = `${process.env.REACT_APP_CALENDAR_API_URL}`;
initParams.categoriesUrl = `${process.env.REACT_APP_CATEGORIES_API_URL}`;

// Get the code for the API from the query params
const searchParams = queryString.parse(window.location.search);
initParams.code = searchParams.code ? searchParams.code : CODE_MISSING;
initParams.referringApp = searchParams.app ? searchParams.app : 'web';

let element = document.getElementById(appId);

// Get the code from a dataparam if embedded
initParams.code = initParams.code === CODE_MISSING && element.dataset.code ? element.dataset.code : initParams.code;

// Get the app from data param if embedded
initParams.referringApp = initParams.referringApp === 'web' && element.dataset.app ? element.dataset.app : initParams.referringApp;

// Get fixed height if embedding (e.g., TreeNet)
initParams.height = element.dataset.height;

// Get fixed width if embedding (e.g., TreeNet)
initParams.width = element.dataset.width;

// Set up Google Analytics
const trackingId = `${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`;
ReactGA.initialize(trackingId);
const appToShow = initParams.referringApp + ' | ' + initParams.code;
ReactGA.pageview(appToShow);

// render
ReactDOM.render((
  
    <BrowserRouter>
      <App params={initParams}/>
    </BrowserRouter>

), 
element);